import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { Box } from 'grommet';
import InsertTelephoneStep1 from '../Components/InsertTelephoneStep1';
import InsertOTPPassword from '../Components/InserisciOTPPassword';
import RiepilogoOTP from '../Components/RiepilogoOTP';
import { SetCellNumberLoginCtrl } from '../Controllers/Account/SetCellNumberLoginCtrl';
import { VerifyOtpLoginTelCtrl } from '../Controllers/otpCtrl/VerifyOtpLoginTel';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { logout } from '../Utils/Utility';



class InsertTelephoneNumber extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            telephone: '',
            buttonState: true,
            msgError: '',
            dataSendNum: false,
            dataOTP: false,
            step: 1,
            otp: '',
            buttonStateOtp: true,
            msgErrorOtp: '',
            showTimeoutModal: false,
            status: ''
        }
        this.setTelephone = this.setTelephone.bind(this);
        this.sendCellNumber = this.sendCellNumber.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.otpProcess = this.otpProcess.bind(this);
        this.setOtp = this.setOtp.bind(this);
        this.login = this.login.bind(this)


    }

    nextStep() {
        const { step } = this.state
        this.setState({
            step: step + 1,
        })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({
            step: step - 1,
        })
    }

    firstStep = () => {
        /*const { step } = this.state*/
        this.setState({
            step: 1,
        })
    }

    goHome = () => {
        this.props.history.push('/Home');
    }

    setTelephone = (e) => {

        this.setState({
            telephone: e.target.value,
        }, function () {
            this.disableButton()
        })
    }
    setOtp = (e) => {
        var otpVal = e.target.value;
        var regex = RegExp(/^\d{6,6}$/);
        if (regex.test(otpVal)) {
            this.setState({
                otp: otpVal,
                buttonStateOtp: false,
                msgErrorOtp: ''
            })
        } else if (otpVal.length === 0) {
            this.setState({
                otp: otpVal,
                buttonStateOtp: false,
                msgErrorOtp: ''
            })
        }
        else {
            this.setState({
                otp: otpVal,
                buttonStateOtp: true,
                msgErrorOtp: 'Inserire 6 cifre'
            })
        }
    }

    disableButton = () => {
        var regexTel = RegExp(/^\+(?:[0-9] ?){2,}[0-9]$/);//RegExp('^3\\d[0-9]{7,10}$'); ///^[3]\d{7,10}$/;
        var tel = this.state.telephone;
        var telOK = regexTel.test(tel)

    if (telOK) {
        if (tel.length > 3 && tel.length < 16) {
            this.setState({
                msgError: '',
                buttonState: false,
            })
        }
    }
        else {
            if (tel === '' || tel === undefined || tel === null) {
                this.setState({
                    msgError: 'Il campo non può essere vuoto',
                    buttonState: true
                })
            }
            else {
                this.setState({
                    msgError: 'Inserire un numero internazionale corretto (+112345, +3912345)',
                    buttonState: true
                })
            }
        }
        
    }

    login = () => {
        this.props.history.push({
            pathname: '/login'
        })
    }

    firstStep = () => {
        /*const { step } = this.state*/
        this.setState({
            step: 1,
        })
    }

    sendCellNumber() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        SetCellNumberLoginCtrl(function (data) {
            self.setState({
                dataSendNum: data
            })

        }, function (error) {
            self.setState({
                status: error
            }, function () {
                logout();
                this.props.history.push({
                    pathname: '/login'
                })
            })

        }, this.state, this.state.telephone, token, ids)
    }

    otpProcess() {
        const self = this;
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        VerifyOtpLoginTelCtrl(function (data) {
            self.setState({
                dataOTP: data,
                status: 200
            })
            self.nextStep();

        }, function (status, error) {
            self.setState({
                status: status
            }, function () {
                if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                    this.props.history.push({
                        pathname: '/RegistrationResult',
                        state: this.state,
                        code: 'shop'
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                } else if (status === 406 && error === '5704') {
                    this.setState({
                        msgOtp: 'Codice OTP scaduto',
                        errorOtp: true
                    })
                }  else if (status === 406 && error === '5707') {
                    this.setState({
                        otpError: true,
                        msgErrorOtp: 'Codice OTP non valido'
                    })
                } else if (status === 406 && error === '5708') {
                    this.setState({
                        otpError: true,
                        msgErrorOtp: 'Ultimo tentativo prima del blocco utenza'
                    })
                } else if (status === 406 && error === '5709') {
                    logout();
                } else {
                    self.setState({
                        msgOtp: 'Si è verificato un errore, riprovare!',
                        errorOtp: true
                    })
                }
            })

        }, this.state.telephone, this.state.otp, token, ids)
    }


    form(step) {
        const { telephone, buttonState, msgError, dataSendNum, otp, dataOTP, status, msgErrorOtp, buttonStateOtp, showTimeoutModal } = this.state;
        const values = { telephone, buttonState, msgError, dataSendNum, dataOTP, otp, status, msgErrorOtp, buttonStateOtp, showTimeoutModal };

        // eslint-disable-next-line default-case
        switch (step) {
            case 1:
                return <InsertTelephoneStep1
                    nextStep={this.nextStep}
                    setTelephone={this.setTelephone}
                    values={values}
                    sendCellNumber={this.sendCellNumber}

                />

            case 2:
                return <InsertOTPPassword
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    step={2}
                    otpFunction={this.otpProcess}
                    setOtp={this.setOtp}
                    reinviaOTP={this.sendCellNumber}
                />

            case 3:
                return <RiepilogoOTP
                    firstStep={this.firstStep}
                    login={this.login}
                    values={values}
                />
        }
    }
    render() {
        const { step } = this.state;


        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                {this.form(step)}

            </Box>
        )
    }


}

export default InsertTelephoneNumber = withRouter(InsertTelephoneNumber)